/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Accept_TitleInputs */

const en_spellcheck_accept_title = /** @type {(inputs: Spellcheck_Accept_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept Change`)
};

const fr_spellcheck_accept_title = /** @type {(inputs: Spellcheck_Accept_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepter la correction`)
};

const de_spellcheck_accept_title = /** @type {(inputs: Spellcheck_Accept_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderung akzeptieren`)
};

const it_spellcheck_accept_title = /** @type {(inputs: Spellcheck_Accept_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accetta la modifica`)
};

const ru_spellcheck_accept_title = /** @type {(inputs: Spellcheck_Accept_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Принять изменения`)
};

const es_spellcheck_accept_title = /** @type {(inputs: Spellcheck_Accept_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceptar el cambio`)
};

const zh_cn2_spellcheck_accept_title = /** @type {(inputs: Spellcheck_Accept_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接受改变`)
};

const ja_spellcheck_accept_title = /** @type {(inputs: Spellcheck_Accept_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更を受け入れる`)
};

const hi_spellcheck_accept_title = /** @type {(inputs: Spellcheck_Accept_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बदलाव को स्वीकार करें`)
};

const pt_pt2_spellcheck_accept_title = /** @type {(inputs: Spellcheck_Accept_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceitar alteração`)
};

/**
* | output |
* | --- |
* | "Accept Change" |
*
* @param {Spellcheck_Accept_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_accept_title = /** @type {((inputs?: Spellcheck_Accept_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Accept_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_spellcheck_accept_title(inputs)
	if (locale === "de") return de_spellcheck_accept_title(inputs)
	if (locale === "it") return it_spellcheck_accept_title(inputs)
	if (locale === "ru") return ru_spellcheck_accept_title(inputs)
	if (locale === "es") return es_spellcheck_accept_title(inputs)
	if (locale === "zh-CN") return zh_cn2_spellcheck_accept_title(inputs)
	if (locale === "ja") return ja_spellcheck_accept_title(inputs)
	if (locale === "hi") return hi_spellcheck_accept_title(inputs)
	if (locale === "pt-PT") return pt_pt2_spellcheck_accept_title(inputs)
	return en_spellcheck_accept_title(inputs)
});